import { Skeleton, Row, Col, Card } from 'antd';
import { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import AboutForm from '../components/about/AboutForm';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAboutContent, selectAboutData, selectAboutStatus } from '../redux/aboutSlice';

const AboutPage = () => {
  const dispatch = useDispatch();
  const content = useSelector(selectAboutData);
  const status = useSelector(selectAboutStatus);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchAboutContent());
    }
  }, [status, dispatch]);

  const handleSuccess = () => {
    dispatch(fetchAboutContent());
  };

  if (status === 'loading' && !content) {
    return (
      <Layout title="About Content">
        <Row gutter={[20, 24]}>
          <Col xs={24} lg={12}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Col>
          <Col xs={24}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
          </Col>
          <Col xs={24}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active avatar paragraph={{ rows: 4 }} />
            </Card>
          </Col>
        </Row>
      </Layout>
    );
  }

  return (
    <Layout title="About Content">
      <AboutForm
        initialValues={content}
        onSuccess={handleSuccess}
      />
    </Layout>
  );
};

export default AboutPage;
